import styled from 'styled-components';

/**
 * Layout Components - Unified styled-components layout system
 * Replaces Bootstrap container class for better control and consistency
 */

// PageWrapper: Full-width page container
export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${props => props.bgColor || '#f5f5f5'};
`;

// ContentContainer: Centered content with max-width (replaces Bootstrap container)
export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${props => props.maxWidth || '1200px'};
  margin: 0 auto;
  padding: 0 ${props => props.padding || '20px'};

  @media (max-width: 1400px) {
    max-width: 100%;
    padding: 0 15px;
  }

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

// FullWidthSection: Edge-to-edge sections (no 100vw hacks needed)
export const FullWidthSection = styled.section`
  width: 100%;
  background-color: ${props => props.bgColor || 'transparent'};
`;

// ShadowContainer: PC shadow box effect (replaces Bootstrap container with shadow)
export const ShadowContainer = styled.div`
  background-color: #FFF;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0; /* Prevent flex item from overflowing */

  /* PC: Shadow container with max-width */
  @media (min-width: 1401px) {
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 10px 10px 0 0; /* Only top corners rounded, footer goes edge-to-edge */
    box-shadow: ${props => props.hasShadow ? '0px 0px 15px rgba(136, 136, 136, 0.3)' : 'none'};
    /* Changed from overflow: hidden to allow full-width children to break out */
    overflow: visible;
  }

  /* Tablet and below: Full-width, no shadow */
  @media (max-width: 1400px) {
    width: 100%;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    overflow: visible;
  }
`;

// NoShadowContainer: Full-width container without shadow effects
export const NoShadowContainer = styled.div`
  width: 100%;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

// BorderedContainer: Card-style layout with overflow: hidden
// Used in "Bordered" layout mode - components cannot break out of this container
export const BorderedContainer = styled.div`
  background-color: #FFF;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  /* PC: Shadow container with max-width and overflow: hidden */
  @media (min-width: 1401px) {
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 10px 10px 0 0; /* Only top corners rounded, footer goes edge-to-edge */
    box-shadow: ${props => props.hasShadow ? '0px 0px 15px rgba(136, 136, 136, 0.3)' : 'none'};
    overflow: hidden; /* Key: Children cannot break out of container */
  }

  /* Tablet and below: Full-width, no shadow */
  @media (max-width: 1400px) {
    width: 100%;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    overflow: hidden;
  }
`;

// CleanContainer: Full-width container without restrictions
// Used in "Clean" layout mode - each section can implement its own container-fluid + container pattern
export const CleanContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  /* NO max-width, NO overflow restrictions */
  /* Each section can have full-width backgrounds with centered content */
`;
